export const addServiceValidate = (formValue) => {

    const errors = {}

    if (formValue) {
        if (!formValue.customerName.trim()) {
            errors.customerName = "لطفا نام خریدار را وارد کنید"
        } else {
            delete errors.customerName
        }

        if (!formValue.customerPhone.trim()) {
            errors.customerPhone = "لطفا تلفن خریدار را وارد کنید"
        } else {
            delete errors.customerPhone
        }

        if (!formValue.area.trim()) {
            errors.area = "لطفا نام منطقه را وارد کنید"
        } else {
            delete errors.area
        }

        if (!formValue.ownerName.trim()) {
            errors.ownerName = "لطفا نام مالک را وارد کنید"
        } else {
            delete errors.ownerName
        }

        if (!formValue.ownerPhone.trim()) {
            errors.ownerPhone = "لطفا شماره مالک را وارد کنید"
        } else {
            delete errors.ownerPhone
        }

        if (!formValue.code.trim()) {
            errors.code = "لطفا شماره فایل را وارد کنید"
        } else {
            delete errors.code
        }

        if (formValue.price === "") {
            errors.price = "لطفا رقم را وارد کنید"
        } else {
            delete errors.price
        }

        if (!formValue.result.trim()) {
            errors.result = "لطفا نتیجه را وارد کنید"
        } else {
            delete errors.result
        }

        if (formValue.date == "") {
            errors.date = "لطفا تاریخ را وارد کنید"
        } else {
            delete errors.date
        }

        if (formValue.time == "") {
            errors.time = "لطفا ساعت را وارد کنید"
        } else {
            delete errors.time
        }

    }

    return errors;

}